module.exports = __webpack_public_path__ + "static/media/markdown.2c92d1b9.svg";